import React, { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Theme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { applyThemeMode } from './embedTheme';
import { ThemeMode } from './embedTheme.types';

interface ThemeLayoutProps {
  theme: Theme;
  mode: ThemeMode;
}

export const ThemeLayout: React.FC<ThemeLayoutProps> = ({ theme, mode }) => {
  useLayoutEffect(() => applyThemeMode(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Outlet />
    </ThemeProvider>
  );
};
